import {
  DeviceConfig,
  DeviceConfig_Notification,
  DeviceConfig_Notification_Key,
} from '@wavingroup/iot-core/gen/ts/wavin/sentio/v1/device_config_pb';
import { TFunction } from 'i18next';
import { toCamelCase } from '~/shared/utils/toCamelCase';

/**
 * 
// For i18next-parser:
------ UNSPECIFIED 
t('notification.alerts.unspecified.title')
t('notification.alerts.unspecified.alertDescription')
t('notification.alerts.unspecified.stepsToPerform')
------ ROOM_PERIPHERAL_LOST 
t('notification.alerts.roomPeripheralLost.title')
t('notification.alerts.roomPeripheralLost.alertDescription')
t('notification.alerts.roomPeripheralLost.stepsToPerform')
------ ROOM_TEMPERATURE_CRITICALLY_LOW 
t('notification.alerts.roomTemperatureCriticallyLow.title')
t('notification.alerts.roomTemperatureCriticallyLow.alertDescription')
t('notification.alerts.roomTemperatureCriticallyLow.stepsToPerform')
------ ROOM_TEMPERATURE_CRITICALLY_HIGH 
t('notification.alerts.roomTemperatureCriticallyHigh.title')
t('notification.alerts.roomTemperatureCriticallyHigh.alertDescription')
t('notification.alerts.roomTemperatureCriticallyHigh.stepsToPerform')
------ ROOM_FLOOR_TEMPERATURE_CRITICALLY_LOW 
t('notification.alerts.roomFloorTemperatureCriticallyLow.title')
t('notification.alerts.roomFloorTemperatureCriticallyLow.alertDescription')
t('notification.alerts.roomFloorTemperatureCriticallyLow.stepsToPerform')
------ ROOM_FLOOR_TEMPERATURE_CRITICALLY_HIGH 
t('notification.alerts.roomFloorTemperatureCriticallyHigh.title')
t('notification.alerts.roomFloorTemperatureCriticallyHigh.alertDescription')
t('notification.alerts.roomFloorTemperatureCriticallyHigh.stepsToPerform')
------ ROOM_FROST_PROTECTION_ACTIVE 
t('notification.alerts.roomFrostProtectionActive.title')
t('notification.alerts.roomFrostProtectionActive.alertDescription')
t('notification.alerts.roomFrostProtectionActive.stepsToPerform')
------ ROOM_BATTERY_COVER_OPEN 
t('notification.alerts.roomBatteryCoverOpen.title')
t('notification.alerts.roomBatteryCoverOpen.alertDescription')
t('notification.alerts.roomBatteryCoverOpen.stepsToPerform')
------ ROOM_INCORRECT_PERIPHERAL_INSTALLED 
t('notification.alerts.roomIncorrectPeripheralInstalled.title')
t('notification.alerts.roomIncorrectPeripheralInstalled.alertDescription')
t('notification.alerts.roomIncorrectPeripheralInstalled.stepsToPerform')
------ ROOM_VALVE_STICKING 
t('notification.alerts.roomValveSticking.title')
t('notification.alerts.roomValveSticking.alertDescription')
t('notification.alerts.roomValveSticking.stepsToPerform')
------ ROOM_GENERAL_PROBLEM 
t('notification.alerts.roomGeneralProblem.title')
t('notification.alerts.roomGeneralProblem.alertDescription')
t('notification.alerts.roomGeneralProblem.stepsToPerform')
------ ROOM_DRYER_GENERAL_FAULT 
t('notification.alerts.roomDryerGeneralFault.title')
t('notification.alerts.roomDryerGeneralFault.alertDescription')
t('notification.alerts.roomDryerGeneralFault.stepsToPerform')
------ ROOM_DRYER_MAINTENANCE 
t('notification.alerts.roomDryerMaintenance.title')
t('notification.alerts.roomDryerMaintenance.alertDescription')
t('notification.alerts.roomDryerMaintenance.stepsToPerform')
------ ROOM_CO2_ABOVE_WARNING_LEVEL 
t('notification.alerts.roomCo2AboveWarningLevel.title')
t('notification.alerts.roomCo2AboveWarningLevel.alertDescription')
t('notification.alerts.roomCo2AboveWarningLevel.stepsToPerform')
------ ROOM_BATTERY_LOW 
t('notification.alerts.roomBatteryLow.title')
t('notification.alerts.roomBatteryLow.alertDescription')
t('notification.alerts.roomBatteryLow.stepsToPerform')
------ ROOM_BATTERY_EMPTY 
t('notification.alerts.roomBatteryEmpty.title')
t('notification.alerts.roomBatteryEmpty.alertDescription')
t('notification.alerts.roomBatteryEmpty.stepsToPerform')
------ ROOM_PERIPHERAL_LOW_BATTERY 
t('notification.alerts.roomPeripheralLowBattery.title')
t('notification.alerts.roomPeripheralLowBattery.alertDescription')
t('notification.alerts.roomPeripheralLowBattery.stepsToPerform')
------ ROOM_MULTIPLE_PERIPHERALS_LOW_BATTERY 
t('notification.alerts.roomMultiplePeripheralsLowBattery.title')
t('notification.alerts.roomMultiplePeripheralsLowBattery.alertDescription')
t('notification.alerts.roomMultiplePeripheralsLowBattery.stepsToPerform')
------ ROOM_BLOCKING_HEATING_UNSPECIFIED 
t('notification.alerts.roomBlockingHeatingUnspecified.title')
t('notification.alerts.roomBlockingHeatingUnspecified.alertDescription')
t('notification.alerts.roomBlockingHeatingUnspecified.stepsToPerform')
------ ROOM_BLOCKING_HEATING_UNKNOWN 
t('notification.alerts.roomBlockingHeatingUnknown.title')
t('notification.alerts.roomBlockingHeatingUnknown.alertDescription')
t('notification.alerts.roomBlockingHeatingUnknown.stepsToPerform')
------ ROOM_BLOCKING_HEATING_FLOOR_TEMP 
t('notification.alerts.roomBlockingHeatingFloorTemp.title')
t('notification.alerts.roomBlockingHeatingFloorTemp.alertDescription')
t('notification.alerts.roomBlockingHeatingFloorTemp.stepsToPerform')
------ ROOM_BLOCKING_HEATING_AIR_TEMP 
t('notification.alerts.roomBlockingHeatingAirTemp.title')
t('notification.alerts.roomBlockingHeatingAirTemp.alertDescription')
t('notification.alerts.roomBlockingHeatingAirTemp.stepsToPerform')
------ ROOM_BLOCKING_HEATING_DEW_POINT 
t('notification.alerts.roomBlockingHeatingDewPoint.title')
t('notification.alerts.roomBlockingHeatingDewPoint.alertDescription')
t('notification.alerts.roomBlockingHeatingDewPoint.stepsToPerform')
------ ROOM_BLOCKING_HEATING_OUTDOOR_TEMP 
t('notification.alerts.roomBlockingHeatingOutdoorTemp.title')
t('notification.alerts.roomBlockingHeatingOutdoorTemp.alertDescription')
t('notification.alerts.roomBlockingHeatingOutdoorTemp.stepsToPerform')
------ ROOM_BLOCKING_HEATING_FAULT 
t('notification.alerts.roomBlockingHeatingFault.title')
t('notification.alerts.roomBlockingHeatingFault.alertDescription')
t('notification.alerts.roomBlockingHeatingFault.stepsToPerform')
------ ROOM_BLOCKING_HEATING_FAULT_HTCO 
t('notification.alerts.roomBlockingHeatingFaultHtco.title')
t('notification.alerts.roomBlockingHeatingFaultHtco.alertDescription')
t('notification.alerts.roomBlockingHeatingFaultHtco.stepsToPerform')
------ ROOM_BLOCKING_HEATING_PERIODIC_ACTIVATION 
t('notification.alerts.roomBlockingHeatingPeriodicActivation.title')
t('notification.alerts.roomBlockingHeatingPeriodicActivation.alertDescription')
t('notification.alerts.roomBlockingHeatingPeriodicActivation.stepsToPerform')
------ ROOM_BLOCKING_HEATING_HCW_SOURCE_NOT_RELEASED 
t('notification.alerts.roomBlockingHeatingHcwSourceNotReleased.title')
t('notification.alerts.roomBlockingHeatingHcwSourceNotReleased.alertDescription')
t('notification.alerts.roomBlockingHeatingHcwSourceNotReleased.stepsToPerform')
------ ROOM_BLOCKING_HEATING_ROOM_MODE 
t('notification.alerts.roomBlockingHeatingRoomMode.title')
t('notification.alerts.roomBlockingHeatingRoomMode.alertDescription')
t('notification.alerts.roomBlockingHeatingRoomMode.stepsToPerform')
------ ROOM_BLOCKING_HEATING_NO_OUTPUT 
t('notification.alerts.roomBlockingHeatingNoOutput.title')
t('notification.alerts.roomBlockingHeatingNoOutput.alertDescription')
t('notification.alerts.roomBlockingHeatingNoOutput.stepsToPerform')
------ ROOM_BLOCKING_HEATING_FIRST_OPEN_ACTIVATION 
t('notification.alerts.roomBlockingHeatingFirstOpenActivation.title')
t('notification.alerts.roomBlockingHeatingFirstOpenActivation.alertDescription')
t('notification.alerts.roomBlockingHeatingFirstOpenActivation.stepsToPerform')
------ ROOM_BLOCKING_HEATING_ROOM_WITH_NO_TEMP_SOURCE 
t('notification.alerts.roomBlockingHeatingRoomWithNoTempSource.title')
t('notification.alerts.roomBlockingHeatingRoomWithNoTempSource.alertDescription')
t('notification.alerts.roomBlockingHeatingRoomWithNoTempSource.stepsToPerform')
------ ROOM_BLOCKING_HEATING_HCWS_ELEMENTS_BLOCKED 
t('notification.alerts.roomBlockingHeatingHcwsElementsBlocked.title')
t('notification.alerts.roomBlockingHeatingHcwsElementsBlocked.alertDescription')
t('notification.alerts.roomBlockingHeatingHcwsElementsBlocked.stepsToPerform')
------ ROOM_BLOCKING_HEATING_SUPPLIER_UNAVAILABLE 
t('notification.alerts.roomBlockingHeatingSupplierUnavailable.title')
t('notification.alerts.roomBlockingHeatingSupplierUnavailable.alertDescription')
t('notification.alerts.roomBlockingHeatingSupplierUnavailable.stepsToPerform')
------ ROOM_BLOCKING_HEATING_NO_SUPPLIER 
t('notification.alerts.roomBlockingHeatingNoSupplier.title')
t('notification.alerts.roomBlockingHeatingNoSupplier.alertDescription')
t('notification.alerts.roomBlockingHeatingNoSupplier.stepsToPerform')
------ ROOM_BLOCKING_COOLING_UNSPECIFIED 
t('notification.alerts.roomBlockingCoolingUnspecified.title')
t('notification.alerts.roomBlockingCoolingUnspecified.alertDescription')
t('notification.alerts.roomBlockingCoolingUnspecified.stepsToPerform')
------ ROOM_BLOCKING_COOLING_UNKNOWN 
t('notification.alerts.roomBlockingCoolingUnknown.title')
t('notification.alerts.roomBlockingCoolingUnknown.alertDescription')
t('notification.alerts.roomBlockingCoolingUnknown.stepsToPerform')
------ ROOM_BLOCKING_COOLING_FLOOR_TEMP 
t('notification.alerts.roomBlockingCoolingFloorTemp.title')
t('notification.alerts.roomBlockingCoolingFloorTemp.alertDescription')
t('notification.alerts.roomBlockingCoolingFloorTemp.stepsToPerform')
------ ROOM_BLOCKING_COOLING_AIR_TEMP 
t('notification.alerts.roomBlockingCoolingAirTemp.title')
t('notification.alerts.roomBlockingCoolingAirTemp.alertDescription')
t('notification.alerts.roomBlockingCoolingAirTemp.stepsToPerform')
------ ROOM_BLOCKING_COOLING_DEW_POINT 
t('notification.alerts.roomBlockingCoolingDewPoint.title')
t('notification.alerts.roomBlockingCoolingDewPoint.alertDescription')
t('notification.alerts.roomBlockingCoolingDewPoint.stepsToPerform')
------ ROOM_BLOCKING_COOLING_OUTDOOR_TEMP 
t('notification.alerts.roomBlockingCoolingOutdoorTemp.title')
t('notification.alerts.roomBlockingCoolingOutdoorTemp.alertDescription')
t('notification.alerts.roomBlockingCoolingOutdoorTemp.stepsToPerform')
------ ROOM_BLOCKING_COOLING_FAULT 
t('notification.alerts.roomBlockingCoolingFault.title')
t('notification.alerts.roomBlockingCoolingFault.alertDescription')
t('notification.alerts.roomBlockingCoolingFault.stepsToPerform')
------ ROOM_BLOCKING_COOLING_FAULT_HTCO 
t('notification.alerts.roomBlockingCoolingFaultHtco.title')
t('notification.alerts.roomBlockingCoolingFaultHtco.alertDescription')
t('notification.alerts.roomBlockingCoolingFaultHtco.stepsToPerform')
------ ROOM_BLOCKING_COOLING_PERIODIC_ACTIVATION 
t('notification.alerts.roomBlockingCoolingPeriodicActivation.title')
t('notification.alerts.roomBlockingCoolingPeriodicActivation.alertDescription')
t('notification.alerts.roomBlockingCoolingPeriodicActivation.stepsToPerform')
------ ROOM_BLOCKING_COOLING_HCW_SOURCE_NOT_RELEASED 
t('notification.alerts.roomBlockingCoolingHcwSourceNotReleased.title')
t('notification.alerts.roomBlockingCoolingHcwSourceNotReleased.alertDescription')
t('notification.alerts.roomBlockingCoolingHcwSourceNotReleased.stepsToPerform')
------ ROOM_BLOCKING_COOLING_ROOM_MODE 
t('notification.alerts.roomBlockingCoolingRoomMode.title')
t('notification.alerts.roomBlockingCoolingRoomMode.alertDescription')
t('notification.alerts.roomBlockingCoolingRoomMode.stepsToPerform')
------ ROOM_BLOCKING_COOLING_NO_OUTPUT 
t('notification.alerts.roomBlockingCoolingNoOutput.title')
t('notification.alerts.roomBlockingCoolingNoOutput.alertDescription')
t('notification.alerts.roomBlockingCoolingNoOutput.stepsToPerform')
------ ROOM_BLOCKING_COOLING_FIRST_OPEN_ACTIVATION 
t('notification.alerts.roomBlockingCoolingFirstOpenActivation.title')
t('notification.alerts.roomBlockingCoolingFirstOpenActivation.alertDescription')
t('notification.alerts.roomBlockingCoolingFirstOpenActivation.stepsToPerform')
------ ROOM_BLOCKING_COOLING_ROOM_WITH_NO_TEMP_SOURCE 
t('notification.alerts.roomBlockingCoolingRoomWithNoTempSource.title')
t('notification.alerts.roomBlockingCoolingRoomWithNoTempSource.alertDescription')
t('notification.alerts.roomBlockingCoolingRoomWithNoTempSource.stepsToPerform')
------ ROOM_BLOCKING_COOLING_HCWS_ELEMENTS_BLOCKED 
t('notification.alerts.roomBlockingCoolingHcwsElementsBlocked.title')
t('notification.alerts.roomBlockingCoolingHcwsElementsBlocked.alertDescription')
t('notification.alerts.roomBlockingCoolingHcwsElementsBlocked.stepsToPerform')
------ ROOM_BLOCKING_COOLING_SUPPLIER_UNAVAILABLE 
t('notification.alerts.roomBlockingCoolingSupplierUnavailable.title')
t('notification.alerts.roomBlockingCoolingSupplierUnavailable.alertDescription')
t('notification.alerts.roomBlockingCoolingSupplierUnavailable.stepsToPerform')
------ ROOM_BLOCKING_COOLING_NO_SUPPLIER 
t('notification.alerts.roomBlockingCoolingNoSupplier.title')
t('notification.alerts.roomBlockingCoolingNoSupplier.alertDescription')
t('notification.alerts.roomBlockingCoolingNoSupplier.stepsToPerform')
------ DHW_CRITICALLY_LOW_PRESSURE 
t('notification.alerts.dhwCriticallyLowPressure.title')
t('notification.alerts.dhwCriticallyLowPressure.alertDescription')
t('notification.alerts.dhwCriticallyLowPressure.stepsToPerform')
------ DHW_LOW_PRESSURE 
t('notification.alerts.dhwLowPressure.title')
t('notification.alerts.dhwLowPressure.alertDescription')
t('notification.alerts.dhwLowPressure.stepsToPerform')
------ DHW_HIGH_PRESSURE 
t('notification.alerts.dhwHighPressure.title')
t('notification.alerts.dhwHighPressure.alertDescription')
t('notification.alerts.dhwHighPressure.stepsToPerform')
------ DHW_LOW_ENERGY 
t('notification.alerts.dhwLowEnergy.title')
t('notification.alerts.dhwLowEnergy.alertDescription')
t('notification.alerts.dhwLowEnergy.stepsToPerform')
------ DHW_HIGH_TEMPERATURE 
t('notification.alerts.dhwHighTemperature.title')
t('notification.alerts.dhwHighTemperature.alertDescription')
t('notification.alerts.dhwHighTemperature.stepsToPerform')
------ DHW_DHI_SENSOR_FAILURE 
t('notification.alerts.dhwDhiSensorFailure.title')
t('notification.alerts.dhwDhiSensorFailure.alertDescription')
t('notification.alerts.dhwDhiSensorFailure.stepsToPerform')
------ DHW_DHO_SENSOR_FAILURE 
t('notification.alerts.dhwDhoSensorFailure.title')
t('notification.alerts.dhwDhoSensorFailure.alertDescription')
t('notification.alerts.dhwDhoSensorFailure.stepsToPerform')
------ DHW_DHW_SENSOR_FAILURE 
t('notification.alerts.dhwDhwSensorFailure.title')
t('notification.alerts.dhwDhwSensorFailure.alertDescription')
t('notification.alerts.dhwDhwSensorFailure.stepsToPerform')
------ DHW_DCW_SENSOR_FAILURE 
t('notification.alerts.dhwDcwSensorFailure.title')
t('notification.alerts.dhwDcwSensorFailure.alertDescription')
t('notification.alerts.dhwDcwSensorFailure.stepsToPerform')
------ DHW_MOTOR_FAILURE 
t('notification.alerts.dhwMotorFailure.title')
t('notification.alerts.dhwMotorFailure.alertDescription')
t('notification.alerts.dhwMotorFailure.stepsToPerform')
------ DHW_PRESSURE_SENSOR_FAILURE 
t('notification.alerts.dhwPressureSensorFailure.title')
t('notification.alerts.dhwPressureSensorFailure.alertDescription')
t('notification.alerts.dhwPressureSensorFailure.stepsToPerform')
------ DHW_FLOW_SENSOR_FAILURE 
t('notification.alerts.dhwFlowSensorFailure.title')
t('notification.alerts.dhwFlowSensorFailure.alertDescription')
t('notification.alerts.dhwFlowSensorFailure.stepsToPerform')
------ DHW_CIRCULATION_SENSOR_FAILURE 
t('notification.alerts.dhwCirculationSensorFailure.title')
t('notification.alerts.dhwCirculationSensorFailure.alertDescription')
t('notification.alerts.dhwCirculationSensorFailure.stepsToPerform')
------ DHW_HEATING_MOTOR_FAILURE 
t('notification.alerts.dhwHeatingMotorFailure.title')
t('notification.alerts.dhwHeatingMotorFailure.alertDescription')
t('notification.alerts.dhwHeatingMotorFailure.stepsToPerform')
------ DHW_HEATING_MOTOR_STUCK 
t('notification.alerts.dhwHeatingMotorStuck.title')
t('notification.alerts.dhwHeatingMotorStuck.alertDescription')
t('notification.alerts.dhwHeatingMotorStuck.stepsToPerform')
------ VENTILATION_FILTERS_TO_BE_REPLACED 
t('notification.alerts.ventilationFiltersToBeReplaced.title')
t('notification.alerts.ventilationFiltersToBeReplaced.alertDescription')
t('notification.alerts.ventilationFiltersToBeReplaced.stepsToPerform')
------ VENTILATION_CONNECTION_LOST 
t('notification.alerts.ventilationConnectionLost.title')
t('notification.alerts.ventilationConnectionLost.alertDescription')
t('notification.alerts.ventilationConnectionLost.stepsToPerform')
------ VENTILATION_RESTART 
t('notification.alerts.ventilationRestart.title')
t('notification.alerts.ventilationRestart.alertDescription')
t('notification.alerts.ventilationRestart.stepsToPerform')
------ VENTILATION_GENERAL_ISSUE 
t('notification.alerts.ventilationGeneralIssue.title')
t('notification.alerts.ventilationGeneralIssue.alertDescription')
t('notification.alerts.ventilationGeneralIssue.stepsToPerform')
------ SYSTEM_EXTERNAL_DEVICE_ISSUE 
t('notification.alerts.systemExternalDeviceIssue.title')
t('notification.alerts.systemExternalDeviceIssue.alertDescription')
t('notification.alerts.systemExternalDeviceIssue.stepsToPerform')
------ SYSTEM_HEAT_PUMP_ISSUE 
t('notification.alerts.systemHeatPumpIssue.title')
t('notification.alerts.systemHeatPumpIssue.alertDescription')
t('notification.alerts.systemHeatPumpIssue.stepsToPerform')
------ SYSTEM_INCOMPATIBLE_PERIPHERAL 
t('notification.alerts.systemIncompatiblePeripheral.title')
t('notification.alerts.systemIncompatiblePeripheral.alertDescription')
t('notification.alerts.systemIncompatiblePeripheral.stepsToPerform')
------ SYSTEM_EXTERNAL_HEAT_PUMP_ISSUE 
t('notification.alerts.systemExternalHeatPumpIssue.title')
t('notification.alerts.systemExternalHeatPumpIssue.alertDescription')
t('notification.alerts.systemExternalHeatPumpIssue.stepsToPerform')
------ VFR_PERIPHERAL_LOST 
t('notification.alerts.vfrPeripheralLost.title')
t('notification.alerts.vfrPeripheralLost.alertDescription')
t('notification.alerts.vfrPeripheralLost.stepsToPerform')
------ SYSTEM_HC_MODE_UPDATED 
t('notification.alerts.systemHcModeUpdated.title')
t('notification.alerts.systemHcModeUpdated.alertDescription')
t('notification.alerts.systemHcModeUpdated.stepsToPerform')
------ SYSTEM_VACATION_MODE_UPDATED 
t('notification.alerts.systemVacationModeUpdated.title')
t('notification.alerts.systemVacationModeUpdated.alertDescription')
t('notification.alerts.systemVacationModeUpdated.stepsToPerform')
------ SYSTEM_STANDBY_MODE_UPDATED 
t('notification.alerts.systemStandbyModeUpdated.title')
t('notification.alerts.systemStandbyModeUpdated.alertDescription')
t('notification.alerts.systemStandbyModeUpdated.stepsToPerform')
------ DEVICE_FIRMWARE_UPDATE_AVAILABLE 
t('notification.alerts.deviceFirmwareUpdateAvailable.title')
t('notification.alerts.deviceFirmwareUpdateAvailable.alertDescription')
t('notification.alerts.deviceFirmwareUpdateAvailable.stepsToPerform')
 * 
 */
export interface SentioNotificationData {
  targetResourceName: string;
  deviceConfig?: DeviceConfig;
}

interface NotificationContent {
  title: string;
  alertDescription: string;
  stepsToPerform: string;
}

const parseNotificationIdFromResource = (
  targetResourceName: string,
): string => {
  const notificationMatch = targetResourceName.match(/notifications\/([^/]+)/);
  return notificationMatch?.[1] ?? '';
};

const findNotificationData = (
  sentioNotification: SentioNotificationData,
): DeviceConfig_Notification | undefined => {
  const { targetResourceName, deviceConfig } = sentioNotification;
  const notificationId = parseNotificationIdFromResource(targetResourceName);

  if (!deviceConfig || !notificationId) {
    return undefined;
  }

  const notificationCollections = [
    deviceConfig.notifications,
    ...deviceConfig.rooms.map((room) => room.notifications),
    ...deviceConfig.domesticHotWaterUnits.map((unit) => unit.notifications),
    ...deviceConfig.ventilationControls.map((control) => control.notifications),
    ...deviceConfig.voltageFreeRelays.map((relay) => relay.notifications),
    ...deviceConfig.outdoorTemperatureSensors.map(
      (sensor) => sensor.notifications,
    ),
  ];

  for (const notifications of notificationCollections) {
    const notification = notifications.find(
      (entry) => entry.id === notificationId,
    );
    if (notification) {
      return notification;
    }
  }

  return undefined;
};

export const getNotificationContent = (
  sentioNotification: SentioNotificationData | undefined,
  roomTitle: string,
  t: TFunction,
): NotificationContent => {
  if (!sentioNotification) {
    return {
      title: '',
      alertDescription: '',
      stepsToPerform: '',
    };
  }

  const notificationData = findNotificationData(sentioNotification);

  if (notificationData?.key === undefined) {
    return {
      title: '',
      alertDescription: '',
      stepsToPerform: '',
    };
  }

  const keyName = Object.keys(DeviceConfig_Notification_Key).find(
    (k) =>
      DeviceConfig_Notification_Key[
        k as keyof typeof DeviceConfig_Notification_Key
      ] === notificationData.key,
  );

  const camelKey = keyName ? toCamelCase(keyName) : 'unspecified';

  const getTranslation = (key: string) => {
    const value = t(key as any, roomTitle ? { roomTitle } : undefined);

    if (typeof value !== 'string' || value === key || value === '') {
      return '-';
    }
    return value;
  };

  return {
    // Key is dynamically constructed from proto enum
    title: getTranslation(`notification.alerts.${camelKey}.title`),
    alertDescription: getTranslation(
      `notification.alerts.${camelKey}.alertDescription`,
    ),
    stepsToPerform: getTranslation(
      `notification.alerts.${camelKey}.stepsToPerform`,
    ),
  };
};
